import { Store } from '@ngrx/store';
import { ReportsState, UnstageItem, StageLinescale, SaveTableExcel } from './store';
import { CategoryAxisLabels, ChartComponent, SeriesLabelsVisualArgs } from '@progress/kendo-angular-charts';
import { Path } from "@progress/kendo-drawing";
import { saveAs } from "@progress/kendo-file-saver";

import { Cell, ModTable } from 'core-lib';
import { Linescale } from './models';
import { Observable, of } from "rxjs";
import { Component, inject, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TextBlockComponent } from 'core/components/storyblok';
// import { HelperViewerComponent } from './helper-viewer/helper-viewer.component';

@Component({
  selector: 'report-tab',
  template: '<div></div>',
  imports: [TextBlockComponent],
  standalone: true
})
export class ReportTab {
  @Input() cell: Cell;
  @Input() manual: any;

  protected store = inject(Store<ReportsState>);
  protected dialog = inject(MatDialog);

  categoryLabels: CategoryAxisLabels = {
    font: '14px Roboto, Arial, sans-serif',
    // rotation: 'auto',
    position: 'start',
    // padding: 16
  };
  cell$: Observable<Cell>;

  private nestedGetter(obj: Object, path: string[]) {
    const pathCopy = path.slice();
    if (path.length)
      return this.nestedGetter(obj[path.splice(0, 1)[0]], pathCopy);
    return obj;
  }

  protected showHelp = (tabId: string, overrideItemId?: string) => {
    // TODO: Lots of change detection shown with this log. Fix
    // console.log('Got tab');
    
    return async (itemId: string) => {
      console.log('Open helper');
      const tabContent = this.manual[tabId];
      console.log(tabContent, itemId);
      
      const { HelperViewerComponent } = await import('./helper-viewer/helper-viewer.component');
      
      this.dialog.open(HelperViewerComponent, {
        data: { helpContent: this.manual[tabId].blocks[overrideItemId || itemId || 'main'] }
      });
    };
  }

  labelVisual(e: SeriesLabelsVisualArgs) {
    return parseFloat(e.text) ? e.createVisual() : new Path({
      stroke: {
        color: 'red',
        width: 1
      },
      visible: false
    });
  }

  itemLabel(e) {
    // console.log(e);
    return Math.round(e.dataItem.label) + '';
  }

  unstageItem(id: string) {
    this.store.dispatch(new UnstageItem(id));
    return false;
  }

  // TODO: Repurposing so I don't have to change the templates
  stageTable(table: ModTable) {
    console.log(table);
    this.store.dispatch(new SaveTableExcel({ tableId: table.id }));
    // this.store.dispatch(new StageTable(table));
    // return true;
  }

  saveLinescale(linescale: Linescale) {
    const id: string = linescale.id || linescale.rsid;
    const dataURI: string = `data:image/png;base64,${linescale.image}`;
    this.store.dispatch(new StageLinescale({ id, dataURI }));
    return true;
  }

  saveChart(chart: ChartComponent, id: string, caption?: string) {
    const today = new Date();
    const fileHash = `${today.getFullYear()}-${today.getMonth()}-${today.getDate()}_${Math.floor(Math.random() * 10000 + 1)}`;
    chart.exportImage().then(dataURI => saveAs(dataURI, `${id}_${fileHash}.png`));
    // TODO: Excluding this for now and simply saving a download
    // chart.exportImage().then(dataURI =>  this.store.dispatch(new StageChart({ id, dataURI, caption })));
    // return true;
  }

  ngOnInit(): void {
    this.cell$ = of(this.cell);
  }

}